import clientHttp from '../tools/clientHttp'
import UserProfile from "../data";
const user = UserProfile.getUserData();
const URL = "/barcode";

export const createBarcodeProccess = async (activateBarcodeDto) => {
    return (await clientHttp.post(`${URL}`, activateBarcodeDto, { silent: true })).data
}

export const getBarcodeById = async (id) => {
    return (await clientHttp.get(`${URL}/${id}`, { silent: true })).data
}

export const getBarcodeProccess = async (code) => {
    return (await clientHttp.get(`${URL}/code/${code}`, { silent: true })).data
}

export const activateBarcodeProccess = async (code) => {
    return (await clientHttp.get(`${URL}/activate/${code}`, { silent: true })).data
}

export const getProductByName = async (name) => {
    const products = (await clientHttp.get(`${URL}/get-product/${name}`, { silent: true })).data
    if (products.length > 0) return products[0];
    return null;
}

export const agregateProduct = async (product) => {
    return clientHttp.post(`${URL}/agregate`, product, { silent: true })
}